import type { RouteConfig } from 'vue-router';

const PassThrough = () => import('@/views/PassThrough.vue');
const DeliveryNotesList = () => import('@/pages/customers/delivery-notes/DeliveryNotesList.vue');

const deliveryNotesRoutes: Array<RouteConfig> = [
  {
    path: 'delivery-notes-new/:group?',
    name: 'delivery-notes-new',
    redirect: (to) => ({ path: `/v3/customers/delivery-notes/${to.params.group ?? ''}` }),
  },
  {
    path: 'delivery-note-new/:uuid?',
    name: 'delivery-note-new',
    props: true,
    redirect: (to) => ({ path: `/v3/customers/delivery-notes/delivery-note/${to.params.uuid ?? ''}` }),
  },
  {
    path: 'templates/delivery-notes-new',
    name: 'template-delivery-notes-new',
    redirect: { path: '/v3/customers/templates/delivery-notes' },
  },
  {
    path: 'templates/delivery-note-new/:uuid?',
    name: 'template-delivery-note-new',
    props: true,
    redirect: (to) => ({ path: `/v3/customers/templates/delivery-notes/delivery-note/${to.params.uuid ?? ''}` }),
  },
  {
    path: 'delivery-notes',
    component: PassThrough,
    alias: ['delivery_note'],
    children: [
      {
        path: ':group?',
        name: 'delivery-notes-list',
        meta: {
          title: 'delivery_notes',
        },
        component: DeliveryNotesList,
        beforeEnter(to, _, next) {
          if (!to.params.group) {
            next({ name: 'delivery-notes-list', params: { group: 'open' } });
          } else {
            next();
          }
        },
      },
    ],
  },
];

export default deliveryNotesRoutes;
